import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import DataTable from 'react-data-table-component';
import { Select2, Select2WColor } from '../../components/Select2';

import * as XLSX from 'xlsx';
import { get, post, put } from '../../controllers/apiController';
import { toast } from 'react-toastify';

const Formlar = () => {
    const [originalFormlar, setOriginalFormlar] = useState([]);
    const [formlar, setFormlar] = useState([]);
    const [etiketler, setEtiketler] = useState([]);
    const [temsilciler, setTemsilciler] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [search, setSearch] = useState("");

    const [selectedLabels, setSelectedLabels] = useState([]);
    const [selectedSource, setSelectedSource] = useState("");

    const [newLabels, setNewLabels] = useState(null);
    const [selectedForm, setSelectedForm] = useState(null);
    const [showLabelsModal, setShowLabelsModal] = useState(false);
    
    const availableSources = [...new Set(originalFormlar.map(lead => lead.LeadInfo.Kaynak))];

    const paginationComponentOptions = {
        rowsPerPageText: 'Sayfa başına satır:',
        rangeSeparatorText: 'toplam',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Tümü',
        firstPageText: 'İlk',
        previousPageText: 'Önceki',
        nextPageText: 'Sonraki',
        lastPageText: 'Son',
        noRowsPerPage: false,
    };

    useEffect(() => {
        document.title = "Formlar | LEVELUP CRM";

        const fetchData = async () => {
            const res = await get("forms/");

            setOriginalFormlar(res);
            setFormlar(res);
        }

        const fetchEtiketler = async () => {
            const res = await get("labels/");

            const etiketlerMapped = res.map(etiket => {
                return {
                    value: etiket.Etiket_ID,
                    label: etiket.Etiket_Adi,
                    color: "#" + etiket.Etiket_Renk
                }
            });

            setEtiketler(etiketlerMapped);
        }

        const fetchTemsilciler = async () => {
            const res = await get("users/company-users");

            const temsilcilerMapped = res.map(temsilci => {
                return {
                    value: temsilci.Kullanici_ID,
                    label: `${temsilci.Kullanici_Adi} ${temsilci.Kullanici_Soyadi}`
                }
            });

            setTemsilciler(temsilcilerMapped);
        }

        const fetchAllData = async () => {
            try {
                await Promise.all([fetchData(), fetchEtiketler(), fetchTemsilciler()]);

                setIsLoading(false);
            } catch (err) {
                toast.error("Veriler alınırken bir hata oluştu!");
            }
        }

        fetchAllData();
    }, []);

    useEffect(() => {
        let filtered = originalFormlar;
    
        if (selectedLabels.length > 0) {
            filtered = filtered.filter(lead =>
                lead.Etiketler && lead.Etiketler.some(etiket => selectedLabels.includes(etiket.Etiket_ID))
            );
        }
    
        if (search) {
            filtered = filtered.filter(item => 
                item.LeadInfo.Adi_Soyadi.toLowerCase().includes(search.toLowerCase())
            );
        }

        if (selectedSource) {
            filtered = filtered.filter(item => 
                item.LeadInfo.Kaynak == selectedSource
            );
        }

        setFormlar(filtered);
    }, [selectedLabels, selectedSource, search, originalFormlar]);

    const handleLabelsEditSubmit = async () => {
        try {
            const changedLabels = await put("forms/change-labels", {
                formID: selectedForm.Form_ID,
                labelIds: newLabels.map(label => label.value)
            });

            setFormlar((formlar) => formlar.map(form =>
                form.Form_ID === selectedForm?.Form_ID
                    ? { ...form, Etiketler: changedLabels }
                    : form
            ));

            toast.success("Etiket başarıyla değiştirildi.");

            setShowLabelsModal(false);
        } catch (error) {
            toast.error(error.response.data.message || "Etiket değiştirilirken bir hata oluştu!");
        }
    }

    const handleSearch = (event) => {
        setSearch(event.target.value);
    };

    const editFormLabels = async (formId) => {
        const form = formlar.find(form => form.Form_ID == formId);
        setSelectedForm(form);
        setNewLabels(etiketler.filter(label =>
            form.Etiketler.some(etiket => etiket.Etiket_ID === label.value)
        ));

        setShowLabelsModal(true);
    }

    const changeTemsilci = async (formID, temsilciId) => {
        try {
            await put("forms/change-user", {
                formID: formID,
                userID: temsilciId
            });

            toast.success("Temsilci başarıyla değiştirildi.");
        } catch (error) {
            toast.error(error.response.data.message || "Temsilci değiştirilirken bir hata oluştu!");
        }
    }

    const removeTemsilci = async (formID) => {
        try {
            await put("forms/change-user", {
                formID: formID
            });

            setFormlar(prevFormlar =>
                prevFormlar.map(form =>
                    form.Form_ID === formID
                        ? { ...form, Temsilci_ID: null }
                        : form
                )
            );

            toast.success("Temsilci başarıyla kaldırıldı.");
        } catch (error) {
            toast.error(error.response.data.message || "Temsilci kaldırılırken bir hata oluştu!");
        }
    }

    const customStyles = {
        noData: {
            style: {
                padding: '24px',
                textAlign: 'center',
            },
        },
        rows: {
            style: {
                padding: '20px 0',
            },
        },
        modalBackdropStyle: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1040
        }
    };

    const columns = [
        {
            name: 'ADI SOYADI',
            cell: row => (
                <a href={`./lead-detail?id=${row.Form_ID}`} className="hstack gap-3">
                    <div>
                        <span className="text-truncate-1-line">{row.LeadInfo.Adi_Soyadi}</span>
                    </div>
                </a>
            ),
            sortable: true
        },
        {
            name: 'TELEFON',
            cell: row => (
                <a href={`tel:${row.LeadInfo.Telefon}`}>{row.LeadInfo.Telefon}</a>
            ),
            sortable: true
        },
        {
            name: (
                <div className="d-flex align-items-center">
                    <span className="me-2">KAYNAK</span>
                    <select
                        className="form-select form-select-sm"
                        value={selectedSource}
                        onChange={(e) => setSelectedSource(e.target.value)}
                        style={{ width: "120px" }} // Boyut ayarlaması
                    >
                        <option value="">Tümü</option>
                        {availableSources.map(option => (
                            <option key={option} value={option}>{option}</option>
                        ))}
                    </select>
                </div>
            ),
            cell: row => (
                <div className="hstack gap-2">
                    <div className="avatar-text avatar-sm">
                        <i className={`feather-${(row.LeadInfo.Kaynak.toLowerCase() == 'meta' ? 'facebook' : (row.LeadInfo.Kaynak.toLowerCase() == 'ads' ? 'google' : 'globe'))}`}></i>
                    </div>
                    <a href="javascript:void(0);">{row.LeadInfo.Kaynak}</a>
                </div>
            ),
            sortable: true
        },
        {
            name: 'TARIH',
            cell: row => {
                const tarih = new Date(row.LeadInfo.Tarih);
                const formatliTarih = `${tarih.getDate().toString().padStart(2, '0')}.${(tarih.getMonth() + 1).toString().padStart(2, '0')}.${tarih.getFullYear()} ${tarih.getHours().toString().padStart(2, '0')}:${tarih.getMinutes().toString().padStart(2, '0')}`;
                return <span className="fw-semibold">{formatliTarih}</span>
            },
            sortable: true
        },
        {
            name: 'ETİKET',
            cell: row => {
                return (
                    <div className="d-flex gap-2">
                        <div className="badge" style={{ backgroundColor: `#${row.Etiketler[0].Etiket_Renk}`, color: `#${row.Etiketler[0].Etiket_Yazi_Renk}` }}>
                            {row.Etiketler[0].Etiket_Adi}
                        </div>
                        {row.Etiketler.length > 1 && (
                            <div className="badge" style={{ backgroundColor: "#efefef", color: "#7f7f7f" }}>
                                +{row.Etiketler.length - 1}
                            </div>
                        )}
                        <button className="text-primary p-0 bg-transparent border-0" onClick={() => editFormLabels(row.Form_ID)}>
                            <i className="feather-edit"></i>
                        </button>
                    </div>
                )
            },
            sortable: true
        },
        {
            name: 'TEMSİLCİ',
            cell: row => {
                return (
                    <div className="d-flex align-items-center gap-1">
                        <Select2
                            key={`temsilci-${row.Form_ID}-${row.Temsilci_ID}`}
                            options={temsilciler}
                            defaultValue={row.Temsilci_ID ? row.Temsilci_ID : null}
                            isSearchable={true}
                            onChange={(e) => { changeTemsilci(row.Form_ID, e?.value || null) }}
                        />
                        <a href="javascript:void(0);"
                            className="text-danger"
                            onClick={() => { removeTemsilci(row.Form_ID) }}>
                            <i className="feather-x"></i>
                        </a>
                    </div>
                )
            },
            sortable: true
        },
        {
            name: 'DETAY',
            cell: row => (
                <div className="d-flex gap-2">
                    <a href={`./lead-detail?id=${row.Form_ID}`} className="avatar-text avatar-md" data-bs-toggle="tooltip" data-bs-original-title="Detay">
                        <i className="feather feather-eye fs-6"></i>
                    </a>
                </div>
            )
        }
    ];

    const handleExport = () => {
        const data = formlar;

        // Excel için verileri sütun başlıklarına göre yeniden düzenleme
        const excelData = data.map(row => {
            return {
                'ADI SOYADI': row.LeadInfo.Adi_Soyadi,
                'TELEFON': row.LeadInfo.Telefon,
                'KAYNAK': row.LeadInfo.Kaynak,
                'TARIH': row.LeadInfo.Tarih,
                'ETİKET': row.Etiketler[0].Etiket_ID,
                'HATIRLATMA TARIH': row.Hatirlatma_Tarihi,
                'TEMSİLCİ': row.Temsilci_ID
            };
        });

        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Formlar");

        // Sütun genişliklerini ayarlama
        const wscols = [
            { wch: 30 }, // KAMPANYA ADI
            { wch: 15 }, // GÖSTERİMLER
            { wch: 15 }, // ERİŞİMLER
            { wch: 15 }, // TIKLAMALAR
            { wch: 10 }, // TBM
            { wch: 15 }, // FORM SAYISI
            { wch: 20 }, // SONUÇ BAŞINA ÜCRET
            { wch: 15 }  // HARCAMA
        ];
        ws['!cols'] = wscols;

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Formlar_${new Date().toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(/\//g, '.').replace(':', '.')}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
    };

    const filterHandler = (e) => {
        const input = e.currentTarget.querySelector('input');
        const value = parseInt(input.value);

        input.checked = !input.checked;

        setSelectedLabels((prevLabels) => {
            if (input.checked) {
                return prevLabels.includes(value) ? prevLabels : [...prevLabels, value];
            } else {
                return prevLabels.filter(label => label !== value);
            }
        });
    };

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item">Formlar</li>
                            </ul>
                        </div>
                        <div className="page-header-right ms-auto">
                            <div className="page-header-right-items">
                                <div className="d-flex d-md-none">
                                    <a href="javascript:void(0)" className="page-header-right-close-toggle">
                                        <i className="feather-arrow-left me-2"></i>
                                        <span>Geri</span>
                                    </a>
                                </div>
                                <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                                    <a href="javascript:void(0);" onClick={handleExport} className="btn btn-icon btn-light-brand">
                                        <i className="feather-printer"></i>
                                    </a>
                                    <a href="javascript:void(0);" className="btn btn-icon btn-light-brand collapsed" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false">
                                        <i className="feather-bar-chart"></i>
                                    </a>
                                    <div className="dropdown">
                                        <a className="btn btn-icon btn-light-brand" data-bs-toggle="dropdown" data-bs-offset="0, 10" data-bs-auto-close="outside">
                                            <i className="feather-filter"></i>
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-end">
                                            {etiketler.map(etiket => (
                                                <div className="dropdown-item" key={etiket.value} onClick={filterHandler}>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" id={`etiket-${etiket.value}`} value={etiket.value} hidden />
                                                        <label className="form-check-label w-100" htmlFor={`etiket-${etiket.value}`}>
                                                            <span className="wd-7 ht-7 rounded-circle d-inline-block me-3" style={{ backgroundColor: etiket.color }}></span>
                                                            <span>{etiket.label}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            ))}
                                            <style>
                                                {`
                                                        .dropdown-item, .form-check-label {
                                                            cursor: pointer;
                                                        }
                                                        .dropdown-item:has(> .form-check input:checked) {
                                                            background-color: #e8f0fe;
                                                        }
                                                        .form-check {
                                                            cursor: pointer;
                                                            padding-left: 0 !important;
                                                        }
                                                    `}
                                            </style>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="d-md-none d-flex align-items-center">
                                <a href="javascript:void(0)" className="page-header-right-open-toggle">
                                    <i className="feather-align-right fs-20"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div id="collapseOne" className="accordion-collapse page-header-collapse collapse">
                        <div className="accordion-body pb-2">
                            <div className="row">
                                <div className="col-xxl-3 col-md-6">
                                    <div className="card stretch stretch-full">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="avatar-text avatar-xl rounded">
                                                        <i className="feather-users"></i>
                                                    </div>
                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                        <span className="d-block">Toplam Form</span>
                                                        <span className="fs-24 fw-bolder d-block">{formlar.length}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-md-6">
                                    <div className="card stretch stretch-full">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="avatar-text avatar-xl rounded">
                                                        <i className="feather-facebook"></i>
                                                    </div>
                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                        <span className="d-block">Facebook'tan Gelenler</span>
                                                        <span className="fs-24 fw-bolder d-block">{formlar.filter(form => form.LeadInfo.Kaynak == 'Meta').length}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-md-6">
                                    <div className="card stretch stretch-full">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="avatar-text avatar-xl rounded">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M11.99 13.9v-3.72h9.36c.14.63.25 1.22.25 2.05c0 5.71-3.83 9.77-9.6 9.77c-5.52 0-10-4.48-10-10S6.48 2 12 2c2.7 0 4.96.99 6.69 2.61l-2.84 2.76c-.72-.68-1.98-1.48-3.85-1.48c-3.31 0-6.01 2.75-6.01 6.12s2.7 6.12 6.01 6.12c3.83 0 5.24-2.65 5.5-4.22h-5.51z" /></svg>
                                                    </div>
                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                        <span className="d-block">Ads'dan Gelenler</span>
                                                        <span className="fs-24 fw-bolder d-block">{formlar.filter(form => form.LeadInfo.Kaynak == 'Ads').length}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-md-6">
                                    <div className="card stretch stretch-full">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="avatar-text avatar-xl rounded">
                                                        <i className="feather-globe"></i>
                                                    </div>
                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                        <span className="d-block">Web Sitesi'nden Gelenler</span>
                                                        <span className="fs-24 fw-bolder d-block">{formlar.filter(form => form.LeadInfo.Kaynak == 'Web Sitesi' || form.LeadInfo.Kaynak == 'Landing Page').length}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-header d-flex align-items-center justify-content-between">
                                         <div className="col-8 col-xs-6">
                                             <h5 className="card-title">Tüm Formlar</h5>
                                         </div>
                                         <div className="col-4 col-xs-6">
                                             <input
                                                 type="text"
                                                 placeholder="Ara..."
                                                 className="form-control"
                                                 value={search}
                                                 onChange={handleSearch}
                                             />
                                         </div>
                                     </div>
                                    <div className="card-body custom-card-action p-2">
                                        {isLoading ? (
                                            <div className="w-100 d-flex align-items-center justify-content-center spinner-wrapper">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Yükleniyor...</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="table-responsive mb-3">
                                                <DataTable
                                                    columns={columns}
                                                    data={formlar}
                                                    className="table table-hover mb-0"
                                                    pagination
                                                    responsive
                                                    noDataComponent="Görüntülenecek kayıt bulunamadı"
                                                    paginationComponentOptions={paginationComponentOptions}
                                                    customStyles={customStyles}
                                                    paginationPerPage={10}
                                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {showLabelsModal && selectedForm && (
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Etiketleri Düzenle</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowLabelsModal(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Etiketler</label>
                                        <Select2WColor
                                            key="labelSelect"
                                            onChange={(val) => setNewLabels(val)}
                                            value={newLabels}
                                            isSearchable
                                            isClearable
                                            options={etiketler}
                                            isMulti
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowLabelsModal(false)}>İptal</button>
                                    <button type="submit" className="btn btn-primary" onClick={handleLabelsEditSubmit}>Kaydet</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {showLabelsModal && (
                    <div style={customStyles.modalBackdropStyle} onClick={() => setShowLabelsModal(false)} />
                )}
            </main>
        </Layout>
    );
};

export default Formlar;
